export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.23-0946.25",
  commitId: "43b0ecf0bf1b8faf87863ece3865ed81bd97d7cd",
  commitTime: "2026-10-23T09:46:25.000Z",
});
